'use strict'

import './RubricList.css'
import React from 'react'

function RubricList (props) {
  const handleRubricClick = (rubricID, rubricCode, event) => {
    event.preventDefault(); // Предотвращаем стандартное действие перехода по ссылке

    const url = new URL(window.location.href);

    const newsIndex = url.pathname.indexOf('/news/');
    if (newsIndex !== -1) {
      url.pathname = url.pathname.substring(0, newsIndex + 6); // +6 чтобы включить "/news/"
      url.search = '';
      url.hash = '';
    }

    // Если "select" отсутствует, просто добавляем "id" в конец пути
    if (rubricCode) {
      url.pathname = `${url.pathname}rubric_${rubricCode}/`;
    }

    const newUrl = url.toString();

    // Добавляем текущий URL в историю
    window.history.pushState({ url: newUrl }, null, newUrl);

    props.setLangLink(url.pathname);
    props.onRubricsChange(rubricID);
  }

  return (
      <div className="rubrics-holder" id="blog-rubric-root">
        <ul className="rubric-list">
          {
            props.rubrics.length ?
              props.rubrics.map(rubric => {
                let active = rubric.hasOwnProperty('ACTIVE') && rubric.ACTIVE
                let xml_id = rubric.hasOwnProperty('XML_ID') ? rubric.XML_ID : ''

                return active ?
                  <li className="rubric active" key={xml_id}>
                    <span>{rubric.NAME}</span>
                  </li> :
                  <li className="rubric" key={xml_id}>
                    <a href={rubric.LINK} onClick={(event) => handleRubricClick(xml_id, rubric.CODE, event)}>{rubric.NAME}</a>
                  </li>;
              }) :
              <></>
          }
        </ul>
      </div>
  )
}

export default RubricList